"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiImplBase = void 0;
var R = __importStar(require("ramda"));
var rxjs_1 = require("rxjs");
var main_1 = require("../main");
var convertToNQError_1 = require("../main/util/convertToNQError");
var getNqErrorFromCommonError = function (err) {
    if (err instanceof DOMException || err instanceof TypeError) {
        return new main_1.NQError(main_1.NQErrorCode.Connectivity, "Fetch timeout: ".concat(err.message), err);
    }
    return (0, convertToNQError_1.convertToNQError)(err);
};
var fetchErrorToSubscriberError = function (err, subscriber) {
    subscriber.error(getNqErrorFromCommonError(err));
};
var ApiImplBase = /** @class */ (function () {
    function ApiImplBase(baseUrl, apiKey, logger, defaultTimeout) {
        this.baseUrl = baseUrl;
        this.apiKey = apiKey;
        this.logger = logger;
        this.defaultTimeout = defaultTimeout;
    }
    ApiImplBase.prototype.combineUrlParts = function (part1, part2) {
        var p1 = part1.replace(/\/?$/g, "");
        var p2 = part2.replace(/^\/?/g, "");
        if (R.isEmpty(part1)) {
            return p2;
        }
        if (R.isEmpty(part2)) {
            return p1;
        }
        return "".concat(p1, "/").concat(p2);
    };
    ApiImplBase.prototype.getApiEndpointUrl = function (endpointName, baseUrl) {
        if (R.isEmpty(baseUrl)) {
            return endpointName;
        }
        var normalBaseUrl = new URL(baseUrl);
        return this.combineUrlParts(normalBaseUrl.href, endpointName);
    };
    ApiImplBase.prototype.fetchRequest = function (url, method, bodyData, fetchTimeout, controller) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var fullUrl, timeoutId, headers, rawResponse, message;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info({ url: url, method: method, bodyData: bodyData }, "fetchRequest");
                        fullUrl = this.getApiEndpointUrl(url, this.baseUrl);
                        timeoutId = setTimeout(function () {
                            var _a;
                            (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.warn("fetchRequest timeout.");
                            controller.abort();
                        }, fetchTimeout);
                        headers = new Headers();
                        if (!R.isNil(bodyData)) {
                            headers.append("Content-Type", "application/json");
                        }
                        if (!R.isNil(this.apiKey)) {
                            headers.append("X-APIKEY", this.apiKey);
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 5, 6]);
                        return [4 /*yield*/, fetch(fullUrl, {
                                method: method,
                                headers: headers,
                                body: R.isNil(bodyData) ? undefined : JSON.stringify(bodyData),
                                signal: controller.signal,
                            })];
                    case 2:
                        rawResponse = _b.sent();
                        if (!!rawResponse.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, rawResponse.text()];
                    case 3:
                        message = _b.sent();
                        throw new main_1.NQError(main_1.NQErrorCode.Server, "Fetch error. URL = \"".concat(fullUrl, "\". StatusCode: ").concat(rawResponse.status, ", Error message: \"").concat(message, "\""));
                    case 4: return [2 /*return*/, rawResponse];
                    case 5:
                        clearTimeout(timeoutId);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ApiImplBase.prototype.request = function (url, method, bodyData, fetchTimeout, convert) {
        var self = this;
        var result = new rxjs_1.Observable(function (subscriber) {
            var controller = new AbortController();
            self.fetchRequest(url, method, bodyData, fetchTimeout, controller)
                .then(function (response) {
                if (response.ok) {
                    convert(response)
                        .then(function (r) {
                        subscriber.next(r);
                        subscriber.complete();
                    })
                        .catch(function (err) {
                        fetchErrorToSubscriberError(err, subscriber);
                    });
                }
                else {
                    fetchErrorToSubscriberError(new main_1.NQError(main_1.NQErrorCode.Client, "Response is not ok in request<T> method."), subscriber);
                }
            })
                .catch(function (err) {
                fetchErrorToSubscriberError(err, subscriber);
            });
            var tearDown = function () {
                var _a;
                (_a = self.logger) === null || _a === void 0 ? void 0 : _a.debug("fetchRequest tear down.");
                controller.abort();
            };
            return tearDown;
        });
        return result;
    };
    ApiImplBase.prototype.requestRx = function (url, method, bodyData, fetchTimeout) {
        var _a;
        if (fetchTimeout === void 0) { fetchTimeout = (_a = this.defaultTimeout) !== null && _a !== void 0 ? _a : 30000; }
        return this.request(url, method, bodyData, fetchTimeout, function (response) {
            return response.json();
        });
    };
    ApiImplBase.prototype.requestBlobRx = function (url, method, bodyData, fetchTimeout) {
        var _a;
        if (fetchTimeout === void 0) { fetchTimeout = (_a = this.defaultTimeout) !== null && _a !== void 0 ? _a : 30000; }
        return this.request(url, method, bodyData, fetchTimeout, function (response) {
            return response.blob();
        });
    };
    return ApiImplBase;
}());
exports.ApiImplBase = ApiImplBase;
//# sourceMappingURL=ApiImplBase.js.map